import {
  BUTTON_SIZE,
  BUTTON_TYPE,
  COLORS,
  DSBottomSheet,
  DSButton,
  DSTextArea,
  useToast,
} from '@repo/design-system/index'
import { QIcon_close_default, QIcon_hammer, QIcon_send } from '@repo/icons/index'
import { useMutation } from '@tanstack/react-query'
import { useState } from 'react'
import { ai_tutor_apis } from '../../../modules/apis'
import { axiosPost } from '../../../modules/axiosHelper'
import { n_ai_tutor } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'

const useRequestMoreCourse = () => {
  return useMutation({
    mutationFn: async (course: string) => {
      const response = await axiosPost(ai_tutor_apis.voc.addMoreJobCategory(), {
        text: course,
      })
      return response
    },
  })
}

const RequestBottomSheet = ({ isOpen, setIsOpen, isLoading, handleSubmit }) => {
  const [requestCourse, setRequestCourse] = useState('')

  const { t } = useTranslation()

  return (
    <DSBottomSheet id={'AITutorCourseRequestBottomSheet'} isOpen={isOpen} setIsOpen={setIsOpen} isWebview>
      <section className="w-full pb-20 px-20 flex justify-between items-center">
        <h1 className="Title2-18Bd">{t(n_ai_tutor.banner.voc_more.modal_title)}</h1>
        <button onClick={() => setIsOpen(false)}>
          <QIcon_close_default width={24} height={24} />
        </button>
      </section>

      <section className="px-20">
        <DSTextArea
          name={'AITutorCourseRequest'}
          rows={4}
          autoFocus
          value={requestCourse}
          setValue={setRequestCourse}
        />
      </section>

      <section className="px-20 py-16 mt-48">
        <DSButton
          size={BUTTON_SIZE.LG}
          isLoading={isLoading}
          disabled={!requestCourse}
          onClick={() => handleSubmit(requestCourse)}
        >
          <DSButton.Label>{t(n_ai_tutor.banner.voc_more.modal_cta)}</DSButton.Label>
        </DSButton>
      </section>
    </DSBottomSheet>
  )
}

const AITutorCourseRequest = () => {
  const [isOpen, setIsOpen] = useState(false)

  const { t } = useTranslation()
  const { toastSuccess, toastError } = useToast()

  const { mutate, isLoading } = useRequestMoreCourse()

  const handleSubmit = (requestCourse) => {
    mutate(requestCourse, {
      onSuccess: () => {
        setIsOpen(false)
        toastSuccess(t(n_ai_tutor.banner.voc_plus.t_success))
      },
      onError: (data) => {
        toastError(t(n_ai_tutor.banner.voc_plus.t_fail))
        console.error(data)
      },
    })
  }

  return (
    <>
      <section className="m-auto flex flex-col gap-y-24 items-center">
        <QIcon_hammer width={64} height={64} />
        <p className="Title1-20Bd text-gray-700 text-center">{t(n_ai_tutor.banner.voc_more.title)}</p>
        <p className="Body1-16Md text-gray-600">{t(n_ai_tutor.banner.voc_more.subtitle)}</p>
        <DSButton
          className="gap-x-4"
          type={BUTTON_TYPE.OUTLINE}
          size={BUTTON_SIZE.MD}
          isIconMode
          onClick={() => setIsOpen(true)}
        >
          <DSButton.Icon alt="send">
            <QIcon_send width={16} height={16} color={COLORS.GRAY300} />
          </DSButton.Icon>
          <DSButton.Label>{t(n_ai_tutor.banner.voc_more.cta)}</DSButton.Label>
        </DSButton>
      </section>
      <RequestBottomSheet isOpen={isOpen} setIsOpen={setIsOpen} isLoading={isLoading} handleSubmit={handleSubmit} />
    </>
  )
}

export default AITutorCourseRequest
